"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.license = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var license = {
  systemId: {
    type: String,
    path: 'SystemId[0]'
  },
  systemDescription: {
    type: String,
    path: 'SystemDescription[0]'
  },
  systemName: {
    type: String,
    path: 'SystemName[0]'
  },
  key: {
    type: String,
    path: 'Key[0]'
  },
  date: {
    type: licenseDate,
    path: 'Date[0]'
  },
  release: {
    type: String,
    path: 'Release[0]'
  },
  user: {
    type: String,
    path: 'User[0]'
  },
  decodeErrorCode: {
    type: String,
    path: 'DecodeErrorCode[0]'
  },
  imagesMax: {
    type: Number,
    path: 'ImagesMax[0]'
  },
  imageGraceLevel: {
    type: String,
    path: 'ImageGraceLevel[0]'
  },
  currentImageCount: {
    type: String,
    path: 'CurrentImageCount[0]'
  },
  components: {
    path: 'Components[0].Component',
    model: {
      name: {
        type: String,
        path: 'Name[0]'
      },
      description: {
        type: String,
        path: 'Desc[0]'
      },
      licenseType: {
        type: String,
        path: 'LicenseType[0]'
      },
      monthsRemaining: {
        type: licenseTime,
        path: 'NumMonthsLeft[0]'
      }
    }
  },
  algorithmGroups: {
    path: 'AlgorithmGroups[0].AlgorithmGroup',
    model: {
      name: {
        type: String,
        path: 'Name[0]'
      },
      number: {
        type: Number,
        path: 'Number[0]'
      },
      count: {
        type: Number,
        path: 'Count[0]'
      },
      countRemaining: {
        type: Number,
        path: 'CurrentCount[0]'
      }
    } // TODO: Algorithms

  }
};
exports.license = license;

function licenseTime(val) {
  return val === 'UNLIMITED' ? Number.POSITIVE_INFINITY : Number(val);
}

function licenseDate(val) {
  var result = null;

  if (val) {
    var _val$split = val.split('-'),
        _val$split2 = _slicedToArray(_val$split, 3),
        year = _val$split2[0],
        month = _val$split2[1],
        day = _val$split2[2]; // 2019-06-25


    result = new Date(year, month - 1, day);
  }

  return result;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/licensing/models/license.js
// module id = 75
// module chunks = 0